<template>
	<div id="crisisEventEscalation">
		<div class="title">危机事件上报</div>
		<div class="content">
			<p>为了保障敏感数据的安全，本模块设置了手机验证码的解锁功能，这意味您需要输入您的手机号码，点击‘发送验证码’，系统将向您的手机发送验证码，您需要在输入正确的验证码后才能解锁并继续本模块的操作。</p>
			<p>请注意，手机验证码仅限于心理工作负责人绑定的手机，我们将通过短信方式发送验证码，以确保您是授权操作人。若您未收到验证码或验证码错误，请检查您的手机是否正常，或者联系我们的客服人员以获取帮助。</p>
			<p>我们深知数据安全对于心理教育工作非常重要，因此，我们建议您妥善保管您的手机和验证码，并不要将其泄露给他人。如果您发现有人未经授权使用您的手机或验证码，请立即与我们联系，我们将及时处理相关问题，以保护我们的权益和数据安全。</p>
			<div class="operationArea">
				<div class="phone">
					<a-input prefix="手机号码" placeholder="仅心理工作负责人可解锁" v-model="phone" />
					<span class="nobind" v-if="!teacherAdmin.phone">您的账户未绑定手机号码，<b @click="bindPhone">请点击绑定</b></span>
				</div>
				<a-input prefix="验证码" size="large" v-model="num">
					<span slot="suffix" :class="phone && teacherAdmin.phone ? 'green' : 'grey'" @click="sendCode">{{sendCode_name}}</span>
				</a-input>
				<a-button type="primary" @click="Unlock" :disabled="!(phone && num)">解锁</a-button>
			</div>
		</div>
	</div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
export default {
	name: '',
	data () {
		return {
			phone: null,
			num: null,
			code: null,
			interval_num: 60,
      interval_id: null,
			sendCode_name: "发送验证码",
			flag: true
		}
	},
	computed: {
		...mapState([
			'teacherAdmin'
		])
	},
	methods: {
		...mapMutations([
			'setNavNum'
		]),
		...mapActions([
			'smsVer'
		]),
		bindPhone () {
			this.setNavNum(6)
			this.$router.push('/userList/useraccount')
		},
		async sendCode () {
			if (!this.flag) return false
			let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (myreg.test(this.phone)) {
				if (this.phone === this.teacherAdmin.phone) {
					// 显示倒计时
					this.interval_id = setInterval(() => {
						this.sendCode_name = `${--this.interval_num}秒后再次发送`;
						if (this.interval_num == 0) {
							this.sendCode_name = "发送验证码";
							this.interval_num = 60;
							this.flag = true;
							clearInterval(this.interval_id);
						}
					}, 1000);
					this.flag = false
					this.code = await this.smsVer(this.phone)
				} else {
					this.$message.error('仅心理工作负责人可解锁~')
				}
			} else {
				this.$message.error('请核对手机号是否有误~')
			}
		},
		Unlock () {
			if (this.phone && this.num && (this.num === this.code)) {
				this.$message.success('解锁成功~')
				this.$router.push('/dataCenter/crisisEventEscalationRecord')
			} else {
				this.$message.error('验证码有误~')
			}
		}
	},
	mounted () {
		console.log(this.teacherAdmin)
	}
}
</script>

<style>
#crisisEventEscalation {
	width: 100%;
	background: #FFFFFF;
	border: 1px solid #E8E8E8;
	margin-bottom: 18px;
}
#crisisEventEscalation .title {
	border-bottom: 1px solid #E8E8E8;
	padding: 16px 24px;
	box-sizing: border-box;
	color: #333333;
	font-weight: bold;
}
#crisisEventEscalation .content {
	padding: 16px 24px;
	box-sizing: border-box;
}
#crisisEventEscalation .content p {
	margin-bottom: 15px;
	line-height: 22px;
}
#crisisEventEscalation .operationArea {
	width: 36%;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	margin-top: 40px;
}
#crisisEventEscalation .operationArea .phone {
	margin-bottom: 10px;
	position: relative;
	width: 100%;
}
#crisisEventEscalation .operationArea .phone b {
	font-weight: normal;
	color: #3061BB;
	cursor: pointer;
}
#crisisEventEscalation .operationArea .phone .nobind {
	position: absolute;
	right: -75%;
	top: 50%;
	transform: translateY(-50%);

}
#crisisEventEscalation .operationArea .ant-input {
	padding-left: 80px!important;
	width: 100%;
	height: 40px;
	border-radius: 6px;
}
#crisisEventEscalation .operationArea .ant-input-suffix span {
	display: inline-block;
	border-left: 2px solid #EEEEEE;
	padding-left: 12px;
	color: rgba(6, 6, 6, 0.30);
	cursor: pointer;
}
#crisisEventEscalation .operationArea .ant-input-suffix span.green {
	color: #04B578;
}
#crisisEventEscalation .operationArea button {
	margin-top: 30px;
	margin-bottom: 40px;
}
</style>
